







import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class SubModalBase extends Vue {
  handleDestroySubModal() {
    this.$store.dispatch('modal/DESTROY_SUB_MODAL');
  }
}
